
import './App.css';
import Weather from './componets/WeatherApp/Weather';
function App() {
  return (
  <div>
    <Weather />
  </div>
  );
}

export default App;
